<textarea id="{{elementId}}" [value]="value" title="Textarea"></textarea>



// WEBPACK FOOTER //
// ./src/app/components/tinymce-editor/tinymce-editor.component.html